import * as React from 'react';
import { View, Text, Button, Icon } from 'native-base';
import Moment from 'moment';
import { Linking, Platform, StyleSheet } from 'react-native';
import WebView from 'react-native-webview';
import sharer from '../../components/sharer';
import ActionButton from 'react-native-action-button';
import DatePicker from '../../components/rn-datepicker';
import * as FileSystem from 'expo-file-system';
import Alert from '../../components/alert';
import CalCalDataApi from '../../api/CalCalDataApi';
import Pdf from '../../components/pdf';
import downloader from '../../components/downloader';
import { ProgressBar } from 'react-native-paper';

export default class StatementView extends React.Component {
	constructor(props) {
		super(props);

		const { customer } = this.props;
		const fromDate = customer.lastStatement || Moment().subtract(3, 'months').format('YYYY-MM-DD');
		__DEV__ && console.log(customer.lastStatement);
		this.state = {
			fromDate,
			toDate: new Date().toISOString().split('T')[0],
			downloadProgress: null,
			html: null
		};
	}

	ensureFolderExists(path) {
		//const path = `${FileSystem.documentDirectory}CalCal`

		return FileSystem.getInfoAsync(path).then(({ exists }) => {
			if (!exists) {
				return FileSystem.makeDirectoryAsync(path);
			} else {
				return Promise.resolve(true);
			}
		});
	}

	async onDownload() {
		//const uri = `https://calc.al/staging/data/statements/statement.php?inline=1&cust=${this.props.customer.id}&from=${this.state.fromDate}&to=${this.state.toDate}`;
		//const uri = `https://calc.al/api/statements/${this.props.customer.id}/${this.state.fromDate}/${this.state.toDate}`;
		/*const uri = 'https://calc.al/pdf/340-Invoice_IN00012_(2018-03-07).pdf';

		const callback = downloadProgress => {
			console.log(downloadProgress);
			const progress = downloadProgress.totalBytesWritten / downloadProgress.totalBytesExpectedToWrite;
			this.setState({
				downloadProgress: progress
			});
		};
		//${FileSystem.documentDirectory
		const path = `file:///sdcard/Download/CalCal`;
		const file = `${path}/Statement-${this.props.customer.id}-${this.state.toDate}.pdf`;

		console.log(`downloading ${uri} to ${file}`);
		//Linking.openURL(uri).catch(err => console.log('An error occurred', err));
		await this.ensureFolderExists(path);
		this.download = FileSystem.createDownloadResumable(
			uri,
			file,
			{
				headers: {
					'X-Token': 'Bearer ' + this.props.jwt
				}
			},
			callback
		);
		try {
			ret = await this.download.downloadAsync();
			console.log(ret);
			//if (this.state.downloadProgress === 1) {
			Alert.alert('Download complete! ' + file);
			Linking.openURL(file).catch(err => console.log('An error occurred', err));
			//}
		} catch (e) {
			console.log('ERROR caught downloadAsync', e);
		}*/
		CalCalDataApi.dataInsert(`statements/${this.props.customer.id}/${this.state.fromDate}/${this.state.toDate}`, {}, this.props.jwt, res => {
			if (res.content) {
				downloader(res.content, 'Statement');
			}
		});
	}

	async onShare() {
		//this will create pdf and give us a direct link. Can share that? Has to be downloaded immediately though, won't last long
		CalCalDataApi.dataInsert(`statements/${this.props.customer.id}/${this.state.fromDate}/${this.state.toDate}`, { base64: true }, this.props.jwt, res => {
			if (res.content) {
				const base64Data = `data:application/pdf;base64,` + res.content;
				console.log('sharing');
				sharer(res.content, 'Statement', res.message);
			} else {
				console.log('no content');
			}
		});
		//showShareActionSheetWithOptions!!!
		/*
		Expo.FileSystem.downloadAsync(
			urlToYourFile,
			Expo.FileSystem.documentDirectory + `test.pdf`)
			.then(({ uri }) => {

				Share.share({
					url: uri,
					title: 'title share',
				});
			})
			.catch(error => {
				console.error(error);
			});
		/*
	  if (this.download == null) {
		  alert('Initiate a download first!');
		  return;
		}
		try {
		  let info = await FileSystem.getInfoAsync(this.download._fileUri);
		  Alert.alert('File Info:', JSON.stringify(info), [{ text: 'OK', onPress: () => {} }]);
		} catch (e) {
		  console.log(e);
		}*/
	}
	async getHtml(path) {
		CalCalDataApi.dataLoad(path, this.props.jwt, res => {
			//console.log(res);
			if (res && res.success) {
				//this.setState({ pdfContent: 'data:application/pdf;base64,' + res.content });
				this.setState({ html: res.html });
			}
		});
	}

	render() {
		const { customer } = this.props;
		const { html } = this.state;
		//const uri = 'https://calc.al/workspace/calcal/data/statements/statement.php?html=1&inline=1&cust=' + customer.id + '&from=' + this.state.fromDate + '&to=' + this.state.toDate;
		!html && this.getHtml('statements/' + customer.id + '/' + this.state.fromDate + '/' + this.state.toDate);
		//todo: this needs chamging to use the API
		let progress = null;

		if (this.state.downloadProgress != null) {
			progress = <ProgressBar style={styles.progress} progress={this.state.downloadProgress} />;
		}

		//console.log(this.state, uri);

		return (
			<View style={{ flex: 1, margin: 20 }}>
				<View style={{ flexDirection: 'row' }}>
					<View style={{ flex: 1 }}>
						<Text>From </Text>
						<DatePicker
							style={{}}
							date={this.state.fromDate}
							mode="date"
							placeholder="Select Date"
							format="YYYY-MM-DD"
							displayFormat="DD/MM/YY"
							confirmBtnText="Confirm"
							cancelBtnText="Cancel"
							customStyles={{
								dateIcon: {
									position: 'absolute',
									left: 0,
									top: 4,
									marginLeft: 0
								},
								dateInput: {
									borderColor: 'rgba(0, 0, 0, 0)',
									marginLeft: 40
								}
							}}
							onDateChange={v => {
								this.setState({ fromDate: v.toISOString().split('T')[0], html: null });
							}}
						/>
					</View>
					<View style={{ flex: 1 }}>
						<Text>To </Text>
						<DatePicker
							style={{}}
							date={this.state.toDate}
							mode="date"
							placeholder="Select Date"
							format="YYYY-MM-DD"
							displayFormat="DD/MM/YY"
							confirmBtnText="Confirm"
							cancelBtnText="Cancel"
							customStyles={{
								dateIcon: {
									position: 'absolute',
									left: 0,
									top: 4,
									marginLeft: 0
								},
								dateInput: {
									borderColor: 'rgba(0, 0, 0, 0)',
									marginLeft: 40
								}
							}}
							onDateChange={v => {
								this.setState({ toDate: v.toISOString().split('T')[0], html: null });
							}}
						/>
					</View>
				</View>
				<View style={{ flexDirection: 'row' }}>
					{Platform.OS != 'web' && (
						<Button iconLeft primary full bordered onPress={() => this.onShare()}>
							<Icon name="share" />
							<Text>Share</Text>
						</Button>
					)}

					<Button iconLeft primary full bordered style={{ marginLeft: 30 }} onPress={() => this.onDownload()}>
						<Icon name="download" />
						<Text>Download</Text>
					</Button>
				</View>
				{progress}
				{Platform.OS == 'web' ? (
					<Pdf htmlContent={html} />
				) : (
					<WebView
						style={{ width: '100%', height: 400, marginHorizontal: -5, flex: 1, backgroundColor: 'transparent' }}
						ref={'webview'}
						scalesPageToFit={true}
						automaticallyAdjustContentInsets={true}
						source={{ html }}
						javaScriptEnabled={false}
						startInLoadingState={false}
						scrollEnabled={false}
						contentInset={{ top: 0, left: 0, bottom: 0, right: 130 }}
					/>
				)}
			</View>
		);
	}
}

const styles = StyleSheet.create({
	progress: {
		marginHorizontal: 10,
		marginVertical: 32
	}
});
/* share

ANDROID
		Intent share = new Intent();
share.setAction(Intent.ACTION_SEND);
share.setType("application/pdf");
share.putExtra(Intent.EXTRA_STREAM, uri);
share.setPackage("com.whatsapp");

activity.startActivity(share);

Expo.IntentLauncherAndroid.startActivityAsync(activity, data)

IOS:
Share.share({
    message: 'Invoice from Fred via CalCal',
    url: 'https://calc.al/staging/data/statements/statement.php?cust=1&from=last&to=2018-02-17',
    title: 'Statement'
  }, {
    // Android only:
    dialogTitle: 'Statement',
    // iOS only:
    excludedActivityTypes: [
      'com.apple.UIKit.activity.PostToTwitter'
    ]
  })
Share.share({
    message: 'Invoice from Fred via CalCal',
    url: 'https://calc.al/staging/data/statements/statement.php?cust=1&from=last&to=2018-02-17', //file:///
    title: 'Statement'
*/
